import type { MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Renders API-sanitized article HTML. Links were rewritten by
 * rewriteArticleHtml (data-link="site" for in-site routes), so a click
 * delegate turns them into client-side navigations.
 */
export function ArticleBody({ html }: { html: string }) {
  const navigate = useNavigate()

  function handleClick(event: MouseEvent<HTMLDivElement>) {
    const anchor = (event.target as HTMLElement).closest('a')
    if (!anchor || anchor.dataset.link !== 'site') return
    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.button !== 0
    ) {
      return
    }
    event.preventDefault()
    navigate(anchor.getAttribute('href') ?? '/')
  }

  return (
    <div
      className="article-body"
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
